import PageHeader from "@/components/PageHeader";
import Footer from "@/components/Footer";

export default function LegalPage({ eyebrow, title, updated, intro, sections, testId }) {
  return (
    <div className="min-h-screen bg-[#0D1117]" data-testid={testId}>
      <PageHeader />
      <main className="px-6 sm:px-12 lg:px-20 pt-28 sm:pt-36 pb-24 text-[#FBF9F5]">
        <div className="max-w-4xl mx-auto">
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#FF4E00] mb-5">{eyebrow}</p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight mb-5" data-testid="legal-title">
            {title}
          </h1>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#9CA3AF] mb-10" data-testid="legal-updated">
            Last updated {updated}
          </p>
          <p className="text-base md:text-lg text-[#D1D5DB] leading-relaxed mb-12" data-testid="legal-intro">
            {intro}
          </p>
          <div className="space-y-6">
            {sections.map((section, index) => (
              <section key={section.title} className="rounded-3xl border border-white/10 bg-white/[0.03] p-6 sm:p-8" data-testid={`legal-section-${index + 1}`}>
                <h2 className="font-serif text-2xl sm:text-3xl font-light text-[#FBF9F5] mb-4">{section.title}</h2>
                {section.paragraphs?.map((paragraph) => (
                  <p key={paragraph.slice(0, 50)} className="text-sm sm:text-base text-[#D1D5DB] leading-relaxed mb-4 last:mb-0">
                    {paragraph}
                  </p>
                ))}
                {section.bullets && (
                  <ul className="list-disc pl-5 space-y-2 text-sm sm:text-base text-[#D1D5DB] leading-relaxed">
                    {section.bullets.map((bullet) => <li key={bullet}>{bullet}</li>)}
                  </ul>
                )}
              </section>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
